<template>
  <div id="app">
    <Header />
    <div class="content-container">
      <router-view/>
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from './components/Footer.vue'
import Header from './components/Header.vue'

export default {
  name: 'App',
  components: {
    Header,
    Footer
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  width: 100%;
}

#app {
  font-family: 'Zen Kaku Gothic New', sans-serif;
  width: 100%;
  overflow-x: hidden;
}

.content-container {
  padding-top: 72px; /* モバイルのヘッダー高さ */
}

@media (min-width: 768px) {
  .content-container {
    padding-top: 83px; /* デスクトップのヘッダー高さ（65px + 上下パディング18px） */
  }
}
</style>